import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core'
import style from '@root-gipro/modules/AdminPanel/styles/adminPanel.module.scss'
import { IState } from '@root-gipro/store/interfaces'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Add } from '@material-ui/icons'
import GetAppIcon from '@material-ui/icons/GetApp'
import {
  getProjectRPC, 
  getProjectRPCExport,
  setProjectAddModalOA
} from '@root-gipro/modules/userProjects/store/actions'
import { SecondaryBtn } from '@root-gipro/shared/Button/Button'
import { useLocation } from 'react-router-dom'
import ProjectRpcTable from '@root-gipro/modules/userProjects/components/Project/ProjectRpc/ProjectRpcTable'
import ProjectAddObjectAnalog
  from '@root-gipro/modules/userProjects/components/Project/ProjectRpc/modals/ProjectAddObjectAnalog/ProjectAddObjectAnalog'
import ProjectModalDeleteOA
  from '@root-gipro/modules/userProjects/components/Project/ProjectRpc/modals/ProjectModalDeleteOA/ProjectModalDeleteOA'

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			borderRadius: 8,
		},
		textField: {
			'& .MuiInputBase-root': {
				width: '300px',
			},
		},
	})
)

const ProjectRpc = () => {
  
	const classes = useStyles()
	const dispatch = useDispatch()
  
	const { isObjectsAnalogLoading, isObjectsAnalogExporting, objectsAnalog } = useSelector((state: IState) => state.userProjects.rpc)

	const { pathname } = useLocation()
	const [urlIdInPath, setUrlIdInPath] = useState<string>(pathname.replace(/[^\d]/g, ''));
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
		setUrlIdInPath(pathname.replace(/[^\d]/g, ''))
	}, [pathname])

	useEffect(() => {
    dispatch(getProjectRPC({ projectId: urlIdInPath }));
	}, [])

  const onClickAddOAHandler = () => {
    dispatch(setProjectAddModalOA({ isOpen: true }));
  };
  
  const onClickExportHandler = () => {
    dispatch(getProjectRPCExport({ projectId: urlIdInPath }));
  };

  useEffect(() => {
    
    if(objectsAnalog?.length) setTotalCount(objectsAnalog.length);
    else setTotalCount(0);
    
  }, [objectsAnalog])

  return (
		<div className='adminPanel-container'>
			<div className={style.adminPanel__header}>
				<div className={style.adminPanel__headerLeft}>
					<IconButton onClick={onClickAddOAHandler} classes={classes}>
						<Add />
					</IconButton>
				</div>
				<div 
          className={style.adminPanel__header__export_container}
          style={{ justifyContent: 'flex-end' }}
        >
					<p style={{ marginRight: '15px' }}>
						Всего объектов-аналогов:&nbsp;
            <span className={style.boldText}>
              {totalCount}
            </span>
					</p>
					<div 
            className={style.adminPanel__header__export_container}
            style={{ position: 'relative', justifyContent: 'flex-end', width: 'auto' }}
          >
						<SecondaryBtn
							className={style.add_btn}
              onClick={onClickExportHandler}
						>
							<GetAppIcon style={{ color: '#3f4f5e' }} fontSize='small' />
							Экспорт
						</SecondaryBtn>

            {isObjectsAnalogExporting && (
              <div style={{ position: 'absolute', bottom: '-17px', right: 0, fontSize: '12px' }} >
                Загрузка...
              </div>
            )}
					</div>
				</div>
			</div>
			<ProjectRpcTable
        objectsAnalog={objectsAnalog}
        loadingObjectsAnalogPage={isObjectsAnalogLoading}
			/>
      
      <ProjectAddObjectAnalog projectId={urlIdInPath} />
      
      <ProjectModalDeleteOA />
		</div>
	)
}

export default ProjectRpc;
